import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchForm from './SearchForm';
import HotBadgeSlider from './HotBadgeSlider';
import FilterBar from './FilterBar';
import ReviewCard from './ReviewCard';

export default function PcReviewPage() {
  const [searchParams] = useSearchParams();

  const [filters, setFilters] = useState({
    보험종류: ['전체'],
    사고유형: ['전체'],
  });

  const [filtersKey, setFiltersKey] = useState(0); // ✅ 강제 리렌더용
  const [sort, setSort] = useState<'recent' | 'view'>('recent');
  const filterRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const typeFromUrl = searchParams.get('type') || '전체';
    const issueFromUrl = searchParams.get('issue') || '전체';

    setFilters({
      보험종류: [typeFromUrl],
      사고유형: [issueFromUrl],
    });

    setFiltersKey((prev) => prev + 1); // ✅ 강제 리렌더 트리거

    if (typeFromUrl || issueFromUrl) {
      setTimeout(() => {
        filterRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [searchParams]);

  return (
    <Wrapper>
      <SearchForm />
      <FilterWrapper ref={filterRef}>
        <HotBadgeSlider />
      </FilterWrapper>
      <FilterBar
        key={`filterbar-${filtersKey}`} // ✅ key 변경으로 강제 리렌더
        selectedFilters={filters}
        onChange={setFilters}
        sort={sort}
        onChangeSort={setSort}
      />
      <ReviewCard
        key={`reviewcard-${filtersKey}`} // ✅ key 변경으로 강제 리렌더
        selectedFilters={filters}
        sort={sort}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 60px 0 360px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FilterWrapper = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
`;
